module.exports = __webpack_public_path__ + "e2ddb9b4789adb06a4c731f110cdf9ce.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2020-01-21/whats-new.html
// module id = 2294
// module chunks = 0